export * from '@discoverer/fuse/directives/scrollbar/public-api';
